export const reactSelectStyleWorkingDays = {
  control: (
    provided: Record<string, unknown>,
    state: { isFocused: boolean }
  ) => ({
    ...provided,
    border: "1px solid #E7E7E7",
    paddingTop: "0rem",
    paddingBottom: "0rem",
    paddingLeft: "0.2rem",
    outline: state.isFocused ? "2px solid #535EF9" : "0px solid #E7E7E7",
    boxShadow: state.isFocused ? "0px 0px 0px #535EF9" : "none",
    "&:hover": {
      outline: state.isFocused ? "2px solid #535EF9" : "0px solid #E7E7E7",
      boxShadow: "0px 0px 0px #535EF9",
    },
  }),
  option: (
    provided: Record<string, unknown>,
    state: { isSelected: boolean }
  ) => ({
    ...provided,
    color: state.isSelected ? "white" : "black",
    background: state.isSelected ? "#535EF9" : "white",
    "&:hover": {
      color: "white",
      background: "#535EF999",
    },
  }),
  menu: (provided: Record<string, unknown>) => ({
    ...provided,
    zIndex: 9999,
  }),
  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
} as const;

export const reactSelectStyle = {
  control: (
    provided: Record<string, unknown>,
    state: { isFocused: boolean }
  ) => ({
    ...provided,
    border: "1px solid #E7E7E7",
    paddingTop: "0.1rem",
    paddingBottom: "0.1rem",
    outline: state.isFocused ? "2px solid #535EF9" : "0px solid #E7E7E7",
    boxShadow: state.isFocused ? "0px 0px 0px #535EF9" : "none",
    "&:hover": {
      outline: state.isFocused ? "1px solid #535EF9" : "1px solid #E7E7E7",
      boxShadow: "0px 0px 0px #535EF9",
    },
  }),
  option: (
    provided: Record<string, unknown>,
    state: { isSelected: boolean }
  ) => ({
    ...provided,
    color: state.isSelected ? "white" : "black",
    background: state.isSelected ? "#535EF9" : "white",
    "&:hover": {
      color: "white",
      background: "#535EF999",
    },
  }),
  menu: (provided: Record<string, unknown>) => ({
    ...provided,
    zIndex: 9999,
  }),
  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
};
